import { render, staticRenderFns } from "./Customwidth.vue?vue&type=template&id=7be2992d&scoped=true"
import script from "./Customwidth.vue?vue&type=script&lang=js"
export * from "./Customwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2992d",
  null
  
)

export default component.exports